import styles from './apiTable.module.css';
import TableButton from './tableButton';
import { SquarePen, X } from 'lucide-react'

function ApiTable({ items = [], onEdit, onDelete, loading }) {
  return (
    <div className={styles.tableContainer}>
      <div className={styles.tableHeader}>
        <div className={styles.headerEntry}>API name</div>
        <div className={styles.headerEntry}>API URL</div>
        <div>{""}</div>
      </div>
      <div className={styles.tableBody}>
        {loading ? (
          <div className={styles.tableRow} style={{ columnSpan: 3 }}>
            <span style={{display:"flex", justifyContent:"center", alignItems:"center", width:"100%", height: "4.8rem"}}>
            Loading credentials...
            </span>
          </div>
        ) : Array.isArray(items) && items.map((item) => (
          <div key={item.id} className={styles.tableRow}>
            <div className={styles.rowEntry} style={{ fontWeight: "500" }}>{item.api_name}</div>
            <div className={styles.rowEntry} style={{ fontStyle: "italic" }}>{item.base_url}</div>
            <div className={styles.rowButtons}>
              <TableButton
                onClick={() => onEdit(item)}
                popoverText={"Edit"}>
                <SquarePen color='white' />
              </TableButton>

              <TableButton
                onClick={() => onDelete(items)}
                popoverText={"Delete"}
                props={{ 'backgroundColor': 'var(--color-error)' }}>
                <X color='white' />
              </TableButton>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ApiTable;